import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles, manager, teamAdmin, teamMember } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { supportLoader } from '../loaders/support';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const AmexSupportComponent = lazy(() => import('../../components/pages/support/amex'));
const HsbcSupportComponent = lazy(() => import('../../components/pages/support/hsbc'));

const IS_AMEX_PROVIDER = globalThis.IS_PLAYWRIGHT_RUNNING
	? globalThis.PLAYWRIGHT_CARD_PROVIDER === 'AMEX'
	: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP;

const supportPath = '/support' as const;

export const supportRoutes = {
	path: supportPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute
					allowedRoles={
						globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
							? ['*']
							: [...defaultAllowedRoles, teamAdmin, teamMember, manager]
					}
				>
					<Suspense fallback={<PageLoader />}>
						{IS_AMEX_PROVIDER ? <AmexSupportComponent /> : <HsbcSupportComponent />}
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				return IS_AMEX_PROVIDER ? supportLoader({ queryClient, ...ctx }) : () => ({});
			},
		},
	],
};
